import MainPage from 'feature/main';
import OrderPage from 'feature/orders';
import OrderDetailsPage from 'feature/orders/details';
import { LoginFlowProvider } from 'feature/login-flow/use-login-flow';
import WelcomePage from 'feature/login-flow/welcome';
import { PATH } from 'config';
import { ReceiptProvider } from 'feature/receipt/use-receipt';
import Receipt from 'feature/receipt';
import ReceiptDonate from 'feature/receipt/types/receipt-donate';
import { StreetParkingProvider } from 'feature/street-parking/use-street-parking';
import StreetParkingAutopay from 'feature/street-parking/street-parking-autopay';
import StreetParkingCities from 'feature/street-parking/street-parking-cities';
import StreetParkingPlates from 'feature/street-parking/street-parking-plates';
import StreetParkingBills from 'feature/street-parking/street-parking-bills';
import { LicensePlatesProvider } from 'feature/license-plates/use-license-plate';
import LicensePlates from 'feature/license-plates';
import MochiPaySetting from 'feature/mochi-pay-flow/setting';
import { MochipayFlowProvider } from 'feature/mochi-pay-flow/use-mochi-pay-flow';
import ServiceInstruction from 'distributor/linebank/feature/service-instruction';
import MapsPage from 'feature/maps';
import CoinsPage from 'feature/coins';
import Expired from './feature/expired';
import Contact from 'feature/contact';

const Routing = [
  { path: PATH.MAIN, component: MainPage },
  { path: PATH.MAPS, component: MapsPage },
  { path: PATH.COINS, component: CoinsPage },
  { path: PATH.ORDERS, component: OrderPage },
  { path: PATH.ORDER_DETAIL, component: OrderDetailsPage },
  { path: PATH.SERVICE_INSTRUCTION, component: ServiceInstruction },
  { path: PATH.EXPIRED, component: Expired },
  { path: PATH.CONTACT, component: Contact },
  {
    path: PATH.USER_INDEX,
    provider: LoginFlowProvider,
    routes: [{ path: PATH.USER_WELCOME, component: WelcomePage }],
  },
  {
    path: PATH.PATH_RECEIPT_INDEX,
    provider: ReceiptProvider,
    routes: [
      { path: PATH.RECEIPT_INDEX, component: Receipt },
      { path: PATH.RECEIPT_DONATE, component: ReceiptDonate },
    ],
  },
  {
    path: PATH.STREET_PARKING_INDEX,
    provider: StreetParkingProvider,
    routes: [
      { path: PATH.STREET_PARKING_AUTOPAY, component: StreetParkingAutopay },
      { path: PATH.STREET_PARKING_CITIES, component: StreetParkingCities },
      { path: PATH.STREET_PARKING_PLATES, component: StreetParkingPlates },
      { path: PATH.STREET_PARKING_BILLS, component: StreetParkingBills },
    ],
  },
  {
    path: PATH.LICENSE_PLATES_INDEX,
    provider: LicensePlatesProvider,
    routes: [{ path: PATH.LICENSE_PLATES_INDEX, component: LicensePlates }],
  },
  {
    path: PATH.MOCHIPAY_FLOW_INDEX,
    provider: MochipayFlowProvider,
    routes: [{ path: PATH.MOCHIPAY_FLOW_SETTING, component: MochiPaySetting }],
  },
];

export default Routing;
